import { render, staticRenderFns } from "./BaseNotificator.vue?vue&type=template&id=15efc77c"
import script from "./BaseNotificator.vue?vue&type=script&lang=js"
export * from "./BaseNotificator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports